import { func, number } from "prop-types";
import React from "react";
import { getPagerPages } from "./pagerMath.js";
import * as R from "ramda";
import cx from "classnames";
import { Link } from "react-router-dom";

const propTypes = {
  totalPages: number,
  currentPage: number,
  getLocationFor: func.isRequired, // pageNum => to value for react-router link
  onPageChange: func,
};

const defaultProps = {
  currentPage: 1,
  totalPages: 1,
};

const Pagination = props => {
  const { totalPages, currentPage, getLocationFor, onPageChange } = props;

  function renderPage(label, pageNum) {
    const isDisabled =
      pageNum === currentPage || pageNum < 1 || pageNum > totalPages;

    const className = cx("pagination__button", {
      "pagination__button--current": pageNum === currentPage,
      "pagination__button--disabled": isDisabled,
    });

    const key = label + pageNum;

    return isDisabled ? (
      <span key={key} className={className} aria-disabled="true">
        {label}
      </span>
    ) : (
      <Link
        to={getLocationFor(pageNum)}
        className={className}
        key={key}
        onClick={() => onPageChange && onPageChange(pageNum)}
      >
        {label}
      </Link>
    );
  }

  const middlePages = getPagerPages({
    currentPage,
    totalPages,
    blockRange: 3,
    firstPage: 1,
  });

  const shouldShowFirstDots = R.head(middlePages) >= 3; // 1 ... 3
  const shouldShowLastDots = totalPages - R.last(middlePages) > 1;
  const shouldShowFirstPage = R.head(middlePages) !== 1;
  const shouldShowLastPage = R.last(middlePages) !== totalPages;

  const chevronLeft = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-left"
      aria-label="Previous page"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );

  const chevronRight = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-right"
      aria-label="Next page"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );

  return (
    <div className="pagination">
      <div className="pagination__pages">
        {renderPage(chevronLeft, currentPage - 1)}
        {shouldShowFirstPage && renderPage(1, 1)}
        {shouldShowFirstDots && <div className="pagination__dots">...</div>}
        {middlePages.map(page => renderPage(page, page))}
        {shouldShowLastDots && <div className="pagination__dots">...</div>}
        {shouldShowLastPage && renderPage(totalPages, totalPages)}
        {renderPage(chevronRight, currentPage + 1)}
      </div>
    </div>
  );
};

Pagination.defaultProps = defaultProps;
Pagination.propTypes = propTypes;
export default Pagination;
